import {
    EngagementFacebook,
    requestFacebookParams
} from '@/lib/analytics/pages/engagement/facebook';
import {
    EngagementInstagram,
    requestInstagramOtherParameters,
    requestInstagramParams
} from '@/lib/analytics/pages/engagement/instagram';
import {
    EngagementLinkedin,
    requestLinkedinParams
} from '@/lib/analytics/pages/engagement/linkedin';
import {
    EngagementPinterest,
    requestPinterestParams
} from '@/lib/analytics/pages/engagement/pinterest';
import {
    EngagementTiktok,
    requestTiktokOtherParameters,
    requestTiktokParams
} from '@/lib/analytics/pages/engagement/tiktok';
import { EngagementX, requestXEngagementParams } from '@/lib/analytics/pages/engagement/x';
import {
    EngagementYoutube,
    requestYoutubeOtherParameters,
    requestYoutubeParams
} from '@/lib/analytics/pages/engagement/youtube';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    X,
    YOUTUBE
} from '@/lib/socialProfile';

export const EngagementConfig = (type) => {
    let config;
    let fields;
    let parameters;
    const waitForSPTransition = true;
    switch (type) {
        case INSTAGRAM:
            config = EngagementInstagram;
            fields = requestInstagramParams;
            parameters = requestInstagramOtherParameters;
            break;
        case FACEBOOK:
            config = EngagementFacebook;
            fields = requestFacebookParams;
            break;
        case LINKEDIN:
            config = EngagementLinkedin;
            fields = requestLinkedinParams;
            break;
        case PINTEREST:
            config = EngagementPinterest;
            fields = requestPinterestParams;
            break;
        case X:
            config = EngagementX;
            fields = requestXEngagementParams;
            break;
        case TIKTOK_BUSINESS:
            config = EngagementTiktok;
            fields = requestTiktokParams;
            parameters = requestTiktokOtherParameters;
            break;
        case YOUTUBE:
            config = EngagementYoutube;
            fields = requestYoutubeParams;
            parameters = requestYoutubeOtherParameters;
            break;
    }
    return { config, fields, parameters, waitForSPTransition };
};
